import React, { ChangeEvent, FC, InputHTMLAttributes } from "react";
import Input from "../Input/Input";

import styles from "./styles.module.scss";

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const TextInput: FC<TextInputProps> = ({
  error = false,
  onChange,
  label,
  ...props
}) => {
  return (
    <div className={styles.inputContainer}>
      <label className={styles.inputLabel}>{label}</label>
      <Input onChange={onChange} {...props} />
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};

export default TextInput;
